import { darken, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import moment from 'moment';

import { RenderMarkdown } from '@components';
import { TERMS_OF_SERVICE_UPDATE_DATE } from '@utils';

export const TosPage = () => {
  const theme = useTheme();
  const { t } = useTranslation('authentication');

  return (
    <Stack spacing={3} p={3} sx={{ backgroundColor: darken(theme.palette.background.paper, 0.2) }}>
      <Stack>
        <Typography variant="h5" color="text.primary" fontWeight={600}>
          {t('signup.legalDialog.General Conditions of Use')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('signup.legalDialog.Update date', {
            date: moment(TERMS_OF_SERVICE_UPDATE_DATE).format('LL'),
          })}
        </Typography>
      </Stack>
      <RenderMarkdown fileName="termOfService" />
    </Stack>
  );
};
